'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

var SearchBar = require('../SearchBar/SearchBar.js');

var MobileNavItem = require('./MobileNavItem/MobileNavItem.js');

var MobileNavDrawer = require('./MobileNavDrawer/MobileNavDrawer.js');

require('../../../primitives/Button/Button.js');

require('../../../primitives/Hero/Hero.js');

var Icon = require('../../../primitives/Icon/Icon.js');

require('../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var MobileNav = function MobileNav(props) {
  var className = props.className,
      activeNavItem = props.activeNavItem,
      headerData = props.headerData;
  var navData = headerData.navData,
      utilityNavData = headerData.utilityNavData;

  var _useState = React.useState(null),
      _useState2 = slicedToArray['default'](_useState, 2),
      activeUtilityNavItem = _useState2[0],
      setActiveUtilityNavItem = _useState2[1];

  var MobileNavClasses = index['default'](className, 'lanl-mobile-nav', activeNavItem ? 'lanl-mobile-nav--active' : '');

  var renderMenuCatagories = function renderMenuCatagories(lc_page_groups, mobileNavItemOpen) {
    return lc_page_groups.map(function (_ref) {
      var name = _ref.name,
          link = _ref.link,
          lc_pages = _ref.lc_pages;

      var _useState3 = React.useState(false),
          _useState4 = slicedToArray['default'](_useState3, 2),
          menuItemOpen = _useState4[0],
          setMenuItemOpen = _useState4[1];

      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
        key: "menu-catagory-".concat(name)
      }, /*#__PURE__*/React__default['default'].createElement(MobileNavItem.MobileNavItem, {
        name: name,
        onClick: function onClick(e) {
          setMenuItemOpen(true);
          e.stopPropagation();
        }
      }), /*#__PURE__*/React__default['default'].createElement(MobileNavDrawer.MobileNavDrawer, {
        open: mobileNavItemOpen && menuItemOpen && activeNavItem,
        className: "primary-gradient drawer-two"
      }, /*#__PURE__*/React__default['default'].createElement(MobileNavItem.MobileNavItem, {
        name: name,
        secondary: true,
        onClick: function onClick(e) {
          setMenuItemOpen(false);
          e.stopPropagation();
        }
      }), /*#__PURE__*/React__default['default'].createElement(MobileNavItem.MobileNavItem, {
        name: "View ".concat(name),
        hasChildren: false,
        link: link
      }), lc_pages.map(function (_ref2) {
        var name = _ref2.name,
            link = _ref2.link;
        return /*#__PURE__*/React__default['default'].createElement(MobileNavItem.MobileNavItem, {
          name: name,
          hasChildren: false,
          link: link,
          key: "group-item-".concat(name)
        });
      })));
    });
  };

  var renderMobileNavItems = function renderMobileNavItems() {
    return navData.map(function (_ref3) {
      var name = _ref3.name,
          lc_page_groups = _ref3.lc_page_groups,
          link = _ref3.link;
      var hasChildren = lc_page_groups.length > 0;

      var _useState5 = React.useState(false),
          _useState6 = slicedToArray['default'](_useState5, 2),
          mobileNavItemOpen = _useState6[0],
          setMobileNavItemOpen = _useState6[1];

      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
        key: "mobile-nav-item-".concat(name)
      }, /*#__PURE__*/React__default['default'].createElement(MobileNavItem.MobileNavItem, {
        name: name,
        hasChildren: hasChildren,
        link: link,
        onClick: function onClick() {
          return setMobileNavItemOpen(true);
        }
      }), /*#__PURE__*/React__default['default'].createElement(MobileNavDrawer.MobileNavDrawer, {
        open: mobileNavItemOpen && activeNavItem,
        className: "primary-gradient"
      }, /*#__PURE__*/React__default['default'].createElement(MobileNavItem.MobileNavItem, {
        name: name,
        secondary: true,
        onClick: function onClick(e) {
          setMobileNavItemOpen(false);
          e.stopPropagation();
        }
      }), /*#__PURE__*/React__default['default'].createElement("ul", null, renderMenuCatagories(lc_page_groups, mobileNavItemOpen))));
    });
  };

  var renderUtilityNavItems = function renderUtilityNavItems() {
    return utilityNavData.map(function (_ref4, i) {
      var name = _ref4.name;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: "utility-nav-mobile-".concat(i),
        className: "utility-nav-mobile-item",
        onClick: function onClick() {
          return setActiveUtilityNavItem(name);
        }
      }, name, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
        icon: "chevron-right",
        size: "xs"
      }));
    });
  };

  var renderActiveUtilityNavItem = function renderActiveUtilityNavItem() {
    var linkData = utilityNavData.find(function (item) {
      return item.name === activeUtilityNavItem;
    });

    if (linkData !== null && linkData !== void 0 && linkData.lc_utility_item) {
      return linkData.lc_utility_item.map(function (_ref5) {
        var name = _ref5.name,
            link = _ref5.link;
        return /*#__PURE__*/React__default['default'].createElement("li", {
          key: "drawer-link-".concat(name),
          className: "drawer-item"
        }, /*#__PURE__*/React__default['default'].createElement("a", {
          href: link
        }, name));
      });
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: MobileNavClasses,
    "data-testid": "lanl-mobile-nav"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "search-container"
  }, /*#__PURE__*/React__default['default'].createElement(SearchBar.SearchBar, {
    open: true
  })), /*#__PURE__*/React__default['default'].createElement("ul", null, renderMobileNavItems(), renderUtilityNavItems(), /*#__PURE__*/React__default['default'].createElement("li", {
    className: "utility-nav-mobile-item"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://discover.lanl.gov/"
  }, "News & Media")), /*#__PURE__*/React__default['default'].createElement("li", {
    className: "utility-nav-mobile-item"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://www.lanl.jobs/"
  }, "Careers")))), /*#__PURE__*/React__default['default'].createElement(MobileNavDrawer.MobileNavDrawer, {
    open: !!activeUtilityNavItem,
    className: "white-bg"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "drawer-close",
    onClick: function onClick() {
      return setActiveUtilityNavItem(null);
    }
  }, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
    icon: "chevron-left",
    size: "sm"
  }), "Back"), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "drawer-item-container"
  }, renderActiveUtilityNavItem())));
};

MobileNav.defaultProps = {};
MobileNav.propTypes = {
  activeNavItem: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  headerData: PropTypes__default['default'].object
};
exports.MobileNav = MobileNav;
exports['default'] = MobileNav;